import React from 'react'

import { ImportBankTransactions } from './ImportBankTransactions'
import { ImportBills } from './ImportBills'
import { useImportData } from './ImportDataContext'
import {
  type BusinessIndustry,
  type CustomAccount,
} from './importDummyDataHelpers'
import { ImportInvoices } from './ImportInvoices'
import { ImportMileage } from './ImportMileage'
import { ImportPayouts } from './ImportPayouts'
import { ImportPayrollManualEntries } from './ImportPayrollManualEntries'
import { ImportTimeTracking } from './ImportTimeTracking'
import { ImportTransfers } from './ImportTransfers'

export interface ImportTilesProps {
  demoName: string
  businessId: string
  industry: BusinessIndustry
  businessAccessToken: string
  defaultCustomAccount: CustomAccount
  defaultCustomDepositoryAccount: CustomAccount
  activationAt: string
}

export const ImportTilesWithDist = ({
  demoName,
  businessId,
  industry,
  businessAccessToken,
  defaultCustomAccount,
  defaultCustomDepositoryAccount,
  activationAt,
}: ImportTilesProps) => {
  const { committedRevenue, committedExpenses, committedBills } = useImportData()
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        gap: '20px',
        maxWidth: '90%',
      }}
    >
      <ImportInvoices
        demoName={demoName}
        businessId={businessId}
        industry={industry}
        businessAccessToken={businessAccessToken}
        defaultCustomAccount={defaultCustomDepositoryAccount}
      />
      <ImportPayouts
        demoName={demoName}
        businessId={businessId}
        industry={industry}
        businessAccessToken={businessAccessToken}
        defaultCustomAccount={defaultCustomDepositoryAccount}
        dist={committedRevenue}
      />
      <ImportBills
        demoName={demoName}
        businessId={businessId}
        industry={industry}
        businessAccessToken={businessAccessToken}
        defaultCustomAccount={defaultCustomAccount}
        dist={committedBills}
      />
      <ImportBankTransactions
        demoName={demoName}
        businessId={businessId}
        industry={industry}
        businessAccessToken={businessAccessToken}
        defaultCustomAccount={defaultCustomAccount}
        dist={committedExpenses}
      />
      <ImportPayrollManualEntries
        demoName={demoName}
        businessId={businessId}
        businessAccessToken={businessAccessToken}
        defaultCustomAccount={defaultCustomDepositoryAccount}
      />
      <ImportTransfers
        demoName={demoName}
        businessId={businessId}
        industry={industry}
        businessAccessToken={businessAccessToken}
        defaultCustomAccount={defaultCustomAccount}
        defaultCustomDepositoryAccount={defaultCustomDepositoryAccount}
      />
      <ImportMileage
        demoName={demoName}
        businessId={businessId}
        industry={industry}
        businessAccessToken={businessAccessToken}
        defaultCustomAccount={defaultCustomAccount}
      />
      <ImportTimeTracking
        demoName={demoName}
        businessId={businessId}
        businessAccessToken={businessAccessToken}
        defaultCustomAccount={defaultCustomAccount}
        activationAt={activationAt}
      />
    </div>
  )
}
